module.exports = __webpack_public_path__ + "static/media/linkPaternImg.284c745b.png";